// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { BaseGeneralSettings } from '@shared/commons/Settings/BaseGeneralSettings';
import { BaseGeneralSettingsInstanceCreator } from '@shared/commons/Settings/BaseGeneralSettingsWrapper';
import { WDSettingsStorageManager } from '../UtilsClasses/WDSettingsStorageManager';
export class WDGeneralSettings extends BaseGeneralSettings {
    reset() {
        const defaultSettings = new WDGeneralSettings();
        this.restore(defaultSettings);
    }
    onSettingsChanged() {
        WDSettingsStorageManager.wasChanged();
        super.onSettingsChanged();
    }
}
export const WDSettings = new WDGeneralSettings();
BaseGeneralSettingsInstanceCreator(WDSettings);
